import * as React from "react"
import { Col, Row } from "antd"
import { GLOBAL_FILTER_IDENTIFIER } from "../filters/reducer"
import DownloadReportButton from "./DownloadReportButton"
import type { FiltersIdentifier } from "../filters/types"
import { KBLink, KBLinkProp } from "../uiKit/KBLink/KBLink"
import { DateRangePickerDataWrapper } from "../screens/reports/components/DateRangePickerDataWrapper"

type Props = {
    children: React.ReactNode
    underline?: boolean
    showRangePicker: boolean
    showDownloadButton: boolean
    identifier: FiltersIdentifier
    haveData: boolean
    kbLink?: KBLinkProp
}
export class ReportTitle extends React.PureComponent<Props> {
    static defaultProps = {
        underline: true,
    }

    render() {
        return (
            <Row className="agenda-title-container">
                <Col span={8}>
                    <h2 className="agenda-title">{this.props.children}</h2>
                </Col>
                <Col span={16}>
                    <Row
                        type="flex"
                        justify="end"
                        style={{
                            flexWrap: "nowrap",
                        }}>
                        {this.props.kbLink ? (
                            <div className={classes.kbLinkWrap}>
                                <KBLink link={this.props.kbLink} />
                            </div>
                        ) : null}
                        {this.props.showRangePicker && (
                            <DateRangePickerDataWrapper
                                identifier={GLOBAL_FILTER_IDENTIFIER}
                                style={{
                                    marginRight: this.props.showDownloadButton ? "1rem" : "0rem",
                                }}
                            />
                        )}
                        {this.props.showDownloadButton && (
                            <DownloadReportButton identifier={this.props.identifier} haveData={this.props.haveData} />
                        )}
                    </Row>
                </Col>
                <style jsx={true} global={true}>
                    {`
                        h2.agenda-title {
                            font-weight: bold;
                        }

                        .agenda-title-container {
                            padding-top: 0.5rem;
                            padding-bottom: 0.1rem;
                            padding-left: 1rem;
                            padding-right: 1rem;
                            margin-bottom: 0;
                            ${this.props.underline ? "border-bottom: 1px solid #e8e8e8;" : ""}
                        }
                    `}
                </style>
            </Row>
        )
    }
}

const classes = {
    kbLinkWrap: "mr-5 pt-1",
}
